import ProjectSession from "../../../project/project-session"
import CRMAccountLookup from "../../../project/inheritance/crm-account"
import ProjectSettings_CRM from "../../../../manager/project/project-settings/crm";

const debug = false
// const debug = "projectViews_getCRMSettings"

export default function projectViews_getCRMSettings(project: ProjectSession): ProjectSettings_CRM {

    let res: ProjectSettings_CRM = {} as ProjectSettings_CRM

    const crmAccountLookup      = new CRMAccountLookup(project.id)
    const crmAccountId          = crmAccountLookup.get()

    // if no CRM Account found then this Customer should not have access to this project
    if (!!crmAccountId) {
        // get settings from current project or from inherit source project if CRM Account is inherited
        // @ts-ignore
        res = crmAccountLookup.isInherited() ? gd.session.projects.get(crmAccountLookup.sourceProjectId)!.settings!.crm : project.settings?.crm
    }

    return res
}